import orderReviewLogo from '~assets/papa-johns-logo-order-review.svg';
import greenNewLogo from '~assets/papa-johns-logo-new-green.svg';
import whiteNewLogo from '~assets/papa-johns-logo-new-white.svg';
import greenNewLogoPt from '~assets/papa-johns-logo-new-green-pt.svg';

export const logoImage = greenNewLogo;

export const whiteLogo = whiteNewLogo;

export const orderReviewNewLogo = orderReviewLogo;
export const logoImagePt = greenNewLogoPt;
